/**
 * bz-perimenopause-guide.js — US MARKET VERSION
 * Perimenopause Focus Guide — Page JavaScript
 * Inherits all logic from adhd-supplements-guide.js pattern.
 * US lensing: $ pricing, US product URLs, FDA structure-function framing.
 * CTAs route to /products/gaba-supplements (US ELITE handle).
 * Created: 2026-04-26 — session 32 wave 2.
 */

/* ─────────────────────────────────────────────────────────────────────
   1. SHARED CONFIG — US market
   ───────────────────────────────────────────────────────────────────── */

window.BZ = window.BZ || {};

BZ.PRODUCTS = BZ.PRODUCTS || {};
BZ.PRODUCTS.us = {
  elite:    { name: 'FOCUS ELITE™',    shortName: 'ELITE',    price: '$65', priceSub: '$54.60/mo', url: '/products/gaba-supplements', cart: '/products/gaba-supplements', purpose: 'Stress-free focus, positive mood & brain health' },
  pro:      { name: 'FOCUS PRO™',      shortName: 'PRO',      price: '$40', priceSub: '$33.60/mo', url: '/products/dopamine-supplements', cart: '/products/dopamine-supplements', purpose: 'Strong focus, motivation & memory' },
  original: { name: 'FOCUS ORIGINAL™', shortName: 'ORIGINAL', price: '$25', priceSub: '$21.00/mo', url: '/products/brainzyme-original-milder-formula', cart: '/products/brainzyme-original-milder-formula', purpose: 'Mild everyday focus & calm mood' }
};

BZ.MARKETS = BZ.MARKETS || {};
BZ.MARKETS.us = {
  lang: 'en',
  proofStrip: [
    '<strong>2,000+</strong> medical professionals trust Brainzyme®',
    '<strong>365-day</strong> money-back guarantee',
    '<strong>GMP & HACCP</strong> certified, made in Scotland'
  ],
  reviewStats: { rating: '4.74', count: '6,020+', source: 'verified reviews' }
};

/* ─────────────────────────────────────────────────────────────────────
   2. LP_CONFIG — Perimenopause lane, US market
   ───────────────────────────────────────────────────────────────────── */

var LP_CONFIG = {
  product: 'elite',
  market: 'us',
  discountCode: '',
  recommendedSku: 'elite'
};

/* ─────────────────────────────────────────────────────────────────────
   3. PRODUCT SHELF — ELITE primary (US handles)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  var market = 'us';
  var p = BZ.PRODUCTS[market];

  var PRODUCTS = [
    {
      key: 'original',
      name: p.original.name,
      pill: null,
      pillClass: '',
      purpose: p.original.purpose,
      price: p.original.price,
      priceSub: p.original.priceSub,
      oneTimeUrl: p.original.cart,
      subUrl: p.original.cart,
      img: 'https://www.brainzyme.com/cdn/shop/files/Packshot_Focus_Single_Pack_Deals_Original_2025.png',
      recommended: false
    },
    {
      key: 'pro',
      name: p.pro.name,
      pill: null,
      pillClass: '',
      purpose: p.pro.purpose,
      price: p.pro.price,
      priceSub: p.pro.priceSub,
      oneTimeUrl: p.pro.cart,
      subUrl: p.pro.cart,
      img: 'https://www.brainzyme.com/cdn/shop/files/Packshot_Focus_Single_Pack_Deals_Pro_2025.png',
      recommended: false
    },
    {
      key: 'elite',
      name: p.elite.name,
      pill: 'STRESS-FREE FOCUS',
      pillClass: 'pill--gold',
      purpose: p.elite.purpose,
      price: p.elite.price,
      priceSub: p.elite.priceSub,
      oneTimeUrl: p.elite.cart,
      subUrl: p.elite.cart,
      img: 'https://www.brainzyme.com/cdn/shop/files/Packshot_Focus_Single_Pack_Deals_Elite_2025.png',
      recommended: true
    }
  ];

  var isDuration = false;

  function renderCard(prod) {
    var recClass = prod.recommended ? ' shelf-card--recommended' : '';
    var recBadge = prod.recommended ? '<div class="shelf-card-rec-badge">Most relevant for hormonal shift support</div>' : '';
    var pillHtml = prod.pill ? '<span class="pill ' + prod.pillClass + '">' + prod.pill + '</span>' : '';
    var url = isDuration ? prod.subUrl : prod.oneTimeUrl;
    var price = isDuration ? prod.priceSub : prod.price;
    return '<div class="shelf-card' + recClass + '">' +
      recBadge +
      pillHtml +
      '<img class="shelf-card-img" src="' + prod.img + '" alt="' + prod.name + '" loading="lazy" onerror="this.style.display=\'none\'">' +
      '<h3 class="shelf-card-name">' + prod.name + '</h3>' +
      '<p class="shelf-card-purpose">' + prod.purpose + '</p>' +
      '<div class="shelf-card-price">' + price + '</div>' +
      '<a class="shelf-card-cta" href="' + url + '">Buy Now — ' + price + '</a>' +
      '<a class="shelf-card-sub-cta" href="' + prod.subUrl + '">Subscribe & Save — ' + prod.priceSub + '</a>' +
      '</div>';
  }

  function renderShelf() {
    var el = document.getElementById('shelfGrid');
    if (!el) return;
    el.innerHTML = PRODUCTS.map(renderCard).join('');
  }

  document.addEventListener('DOMContentLoaded', renderShelf);
})();

/* ─────────────────────────────────────────────────────────────────────
   4. PLAN YOUR PATH — Tab switching + Formula quiz
   ───────────────────────────────────────────────────────────────────── */

(function () {
  document.addEventListener('DOMContentLoaded', function () {

    /* Tab switching */
    var tabs = document.querySelectorAll('.planpath-tab');
    var panels = document.querySelectorAll('.planpath-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.remove('active'); });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var target = tab.getAttribute('data-tab');
        var panel = document.querySelector('.planpath-panel[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });

    /* Formula quiz — perimenopause lane (stepper) */
    var market = 'us';
    var p = BZ.PRODUCTS[market];
    var QUIZ_RESULTS = {
      original: { name: p.original.name, blurb: 'Gentle everyday support — L-Theanine + essential nutrients for steady, calm focus without anything too strong.', url: p.original.cart },
      pro:      { name: p.pro.name,      blurb: 'Strong focus and motivation support with tyrosine + B-complex for demanding work days.', url: p.pro.cart },
      elite:    { name: p.elite.name,    blurb: 'The most complete formula — GABA precursors, adaptogens, and 29 ingredients for stress-free focus and positive mood during demanding life stages.', url: p.elite.cart }
    };

    var stepper = document.getElementById('ppQuizStepper');
    if (stepper) {
      var track = document.getElementById('ppQuizTrack');
      var currentStep = 0;
      var votes = {};

      function goToSlide(n) {
        currentStep = n;
        track.querySelectorAll('.pp-quiz-slide').forEach(function(s) {
          var step = parseInt(s.getAttribute('data-step'), 10);
          var isTarget = (step === n + 1);
          if (isTarget) s.style.display = '';
          s.classList.toggle('active', isTarget);
        });
        if (n >= 3) showResult();
      }

      function showResult() {
        var score = { original: 0, pro: 0, elite: 0 };
        Object.keys(votes).forEach(function(k) { score[votes[k]]++; });
        var winner = 'elite';
        if (score.pro > score.elite && score.pro >= score.original) winner = 'pro';
        else if (score.original > score.elite && score.original > score.pro) winner = 'original';
        var res = QUIZ_RESULTS[winner];
        document.getElementById('ppQuizName').textContent = res.name;
        document.getElementById('ppQuizBlurb').textContent = res.blurb;
        var cta = document.getElementById('ppQuizCta');
        cta.href = res.url;
        cta.textContent = 'Try it — 365-day returns';
      }

      goToSlide(0);

      var advancing = false;
      stepper.querySelectorAll('input[type="radio"]').forEach(function(radio) {
        radio.addEventListener('change', function() {
          stepper.querySelectorAll('input[name="' + radio.name + '"]').forEach(function(r) {
            r.closest('.pp-quiz-option').classList.toggle('selected', r.checked);
          });
          votes[radio.name] = radio.value;
          var targetSlide = parseInt(radio.closest('.pp-quiz-slide').getAttribute('data-step'), 10);
          if (!advancing) {
            advancing = true;
            setTimeout(function() { advancing = false; goToSlide(targetSlide); }, 280);
          }
        });
      });

      var resetBtn = document.getElementById('ppQuizReset');
      if (resetBtn) {
        resetBtn.addEventListener('click', function() {
          votes = {};
          currentStep = 0;
          stepper.querySelectorAll('input[type="radio"]').forEach(function(r) {
            r.checked = false;
            r.closest('.pp-quiz-option').classList.remove('selected');
          });
          var resultSlide = document.getElementById('ppQuizResult');
          if (resultSlide) resultSlide.style.display = 'none';
          goToSlide(0);
        });
      }
    }
  });
})();

/* ─────────────────────────────────────────────────────────────────────
   5. PAGE INTERACTIONS (accordion, symptom checker, progress bar, sticky CTA, stat counters)
   ───────────────────────────────────────────────────────────────────── */

/* Accordion toggle */
function toggleAccordion(btn) {
  var isOpen = btn.getAttribute('aria-expanded') === 'true';
  var panel = btn.nextElementSibling;
  var chevron = btn.querySelector('.accordion-chevron');
  if (isOpen) {
    btn.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = null;
    panel.classList.remove('open');
    if (chevron) chevron.textContent = '+';
  } else {
    btn.setAttribute('aria-expanded', 'true');
    panel.classList.add('open');
    panel.style.maxHeight = panel.scrollHeight + 'px';
    if (chevron) chevron.textContent = '−';
  }
}

/* Symptom / experience checker — Perimenopause lane messages */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.sign-item.selectable');
    var countEl = document.getElementById('symptomCount');
    var resultEl = document.getElementById('symptomResult');
    var count = 0;

    var MESSAGES = [
      null,
      'One experience — the lifestyle section covers simple, evidence-based starting points.',
      'A couple of experiences — calm focus and mood nutritional support is worth exploring.',
      '[N] experiences — your GABA pathways could benefit from targeted nutritional support. Read on.',
      '[N] of 6 experiences — a multi-pathway formula like FOCUS ELITE™ may be a good fit for this life stage.',
      '[N] of 6 experiences — this pattern strongly suggests your nervous system would benefit from precursor-based support.',
      '[N] of 6 experiences — FOCUS ELITE™ was designed for exactly this combination of focus, mood, and stress-relief needs.'
    ];

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var checked = item.getAttribute('aria-checked') === 'true';
        if (checked) {
          item.setAttribute('aria-checked', 'false');
          item.classList.remove('selected');
          count--;
        } else {
          item.setAttribute('aria-checked', 'true');
          item.classList.add('selected');
          count++;
        }
        if (countEl) countEl.textContent = count;
        if (resultEl) {
          if (count === 0) {
            resultEl.innerHTML = '';
            resultEl.style.display = 'none';
          } else {
            var msg = MESSAGES[count] || MESSAGES[MESSAGES.length - 1];
            resultEl.innerHTML = msg.replace('[N]', count);
            resultEl.style.display = 'block';
          }
        }
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.click(); }
      });
    });
  });
})();

/* Buyer's guide checklist progress dots */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.guide-checklist li[data-check]');
    var dots = document.querySelectorAll('.check-dot');
    var label = document.getElementById('checkLabel');
    if (!items.length || !dots.length) return;

    var seen = new Set();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var n = entry.target.getAttribute('data-check');
          seen.add(n);
          dots.forEach(function (d) {
            if (seen.has(d.getAttribute('data-check'))) d.classList.add('active');
          });
          if (label) label.textContent = seen.size + '/6 explored';
        }
      });
    }, { threshold: 0.6 });

    items.forEach(function (item) { obs.observe(item); });
  });
})();

/* Animated stat counters */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('[data-target]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target'));
        var isFloat = target % 1 !== 0;
        var suffix = el.innerHTML.replace(/[\d.]/g, '').trim();
        var start = 0;
        var duration = 1200;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var val = isFloat ? (progress * target).toFixed(1) : Math.floor(progress * target);
          el.innerHTML = val + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { obs.observe(el); });
  });
})();

/* Progress bar + sticky CTA — Perimenopause lane, US */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('progressBar');
    var lbl = document.getElementById('progressLabel');
    var cta = document.getElementById('stickyCta');
    var ctaText = document.getElementById('stickyCtaText');
    var ctaLink = document.getElementById('stickyCtaLink');

    var MESSAGES = [
      { pct: 0.05, text: 'Plant-powered support for hormonal shifts', label: 'Learn more', url: '/products/gaba-supplements' },
      { pct: 0.20, text: 'The GABA pathway approach', label: 'See the science', url: '/products/gaba-supplements' },
      { pct: 0.40, text: '365-day money-back guarantee', label: 'Try FOCUS ELITE Risk-Free', url: '/products/gaba-supplements' },
      { pct: 0.60, text: '6,020+ verified reviews', label: 'Try FOCUS ELITE', url: '/products/gaba-supplements' }
    ];

    function onScroll() {
      var scrolled = window.scrollY;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      var pct = total > 0 ? scrolled / total : 0;

      if (bar) bar.style.width = (pct * 100) + '%';
      if (lbl) lbl.textContent = Math.round(pct * 100) + '%';

      if (cta) {
        if (pct > 0.10 && pct < 0.95) {
          cta.classList.add('visible');
        } else {
          cta.classList.remove('visible');
        }
      }

      var active = MESSAGES[0];
      for (var i = 0; i < MESSAGES.length; i++) {
        if (pct >= MESSAGES[i].pct) active = MESSAGES[i];
      }
      if (ctaText) ctaText.textContent = active.text;
      if (ctaLink) {
        ctaLink.textContent = active.label;
        ctaLink.href = active.url;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();
